class AdpPlainTableController {
  constructor() {
    this.name = 'adpPlainTable';
  }
}

export default AdpPlainTableController;



// WEBPACK FOOTER //
// ./src/app/components/adpPlainTable/adpPlainTable.controller.js